import { render } from "./audit-user.vue?vue&type=template&id=38001741&scoped=true"
import script from "./audit-user.vue?vue&type=script&lang=js"
export * from "./audit-user.vue?vue&type=script&lang=js"

import "./audit-user.vue?vue&type=style&index=0&id=38001741&scoped=true&lang=css"

import exportComponent from "D:\\01_Dev\\Projects\\active\\YouYouXiChe\\smart-car-wash-background\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38001741"]])

export default __exports__